import 'normalize-css';

import React from 'react';
import { navigate } from 'gatsby';

import { AuthProvider } from 'gatsby-plugin-auth';

export const wrapRootElement = ({ element }) => <AuthProvider navigate={navigate}>{element}</AuthProvider>;
